import { Injectable, signal } from '@angular/core';
import { SuiteGroupClusterTimingModel } from '../shared/models/suite-group-cluster-timing.model';

@Injectable({ providedIn: 'root' })
export class SuiteGroupClusterTimingStore {
  private readonly _timings = signal<SuiteGroupClusterTimingModel[]>([]);
  // The clustering board must not collapse a one-member cluster while its timings are still unknown.
  private readonly _isLoaded = signal(false);

  readonly timings = this._timings.asReadonly();
  readonly isLoaded = this._isLoaded.asReadonly();

  /** Replaces the full list of cluster timing overrides and marks the store loaded. */
  setTimings(timings: SuiteGroupClusterTimingModel[]) {
    this._timings.set([...timings]);
    this._isLoaded.set(true);
  }

  /** Swaps only the given cluster's rows, leaving every other cluster's timings untouched. */
  replaceForCluster(clusterId: Guid, timings: SuiteGroupClusterTimingModel[]) {
    this._timings.update((existing) => [...existing.filter((t) => t.clusterId !== clusterId), ...timings]);
  }
}
